// The relay's A2A endpoint for an agent share (RFC-043 model 20): where any
// A2A client reaches the shared agent, with a bearer token the relay signs
// for this person. The token is shown once, here; it stands a week, or
// until the share ends or the person is removed.
import { useState } from "react";
import { api, type AgentToken } from "../api";
import { t } from "../i18n";

export function AgentEndpoint({ shareId }: { shareId: string }) {
  const [tok, setTok] = useState<AgentToken | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);
  const make = async () => {
    setError(null);
    try {
      setTok(await api.agentToken(shareId));
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  };
  const copy = async () => {
    if (!tok) return;
    try {
      await navigator.clipboard.writeText(tok.token);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };
  return (
    <details className="agent-endpoint" data-testid="agent-endpoint">
      <summary className="muted small">{t("session:agentEndpoint")}</summary>
      {tok ? (
        <div>
          <code className="small">{tok.url}</code>
          <div className="row wrap">
            <code className="small token">{tok.token}</code>
            <button type="button" onClick={copy}>
              {copied ? t("session:agentTokenCopied") : t("common:copy")}
            </button>
          </div>
        </div>
      ) : (
        <button type="button" onClick={make}>
          {t("session:agentTokenMake")}
        </button>
      )}
      {error && <p className="error">{error}</p>}
    </details>
  );
}
